export function hideInitialLoader(): void {
  setTimeout(() => {
    document.body.classList.add('app-loaded');
  }, 0);
}

export function emailValidation(email: string): boolean {
  const emailPattern =
    /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;

  return emailPattern.test(email);
}

export function createCustomList<T>(
  itemsCount: number,
  cb: (n: number) => T,
): T[] {
  return [...Array(itemsCount)].map((_, i) => cb(i));
}

export function throttle(cb: (...arg: unknown[]) => void, delay = 250) {
  let shouldWait = false;
  let waitingArgs: unknown[] | null;

  const timeoutFunc = () => {
    if (waitingArgs == null) {
      shouldWait = false;
    } else {
      cb(...waitingArgs);
      waitingArgs = null;
      setTimeout(timeoutFunc, delay);
    }
  };

  return (...args: unknown[]) => {
    if (shouldWait) {
      waitingArgs = args;
      return;
    }

    cb(...args);
    shouldWait = true;
    setTimeout(timeoutFunc, delay);
  };
}

export function getScrollListenerOptions() {
  let supportsPassive = false;

  try {
    const opts = Object.defineProperty({}, 'passive', {
      get() {
        supportsPassive = true;
      },
    });

    const emptyFn = () => {};

    window.addEventListener('testPassive', emptyFn, opts);
    window.removeEventListener('testPassive', emptyFn, opts);
  } catch (_e) {
    //
  }

  return supportsPassive ? { passive: true } : false;
}

export function parseFloatNumber(str: string) {
  const valueMatch = str.match(/[\d.]+/g);

  return valueMatch ? parseFloat(valueMatch[0]) : 0;
}

export function roundNumber(value: number, decimals = 0): number {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}
